import { create } from "zustand";

/**
 * Identifica o que está de fato visível dentro de uma rota quando a rota
 * sozinha não basta: abas que não navegam (Configurações, Channel Manager)
 * e modais que abrem sobre a mesma URL (detalhe da reserva) compartilham o
 * pathname com a tela "de baixo". Quem está no controle desse estado chama
 * useHelpScope(id) enquanto está montado; o DetailedHelpPanel usa o escopo
 * ativo (se existir conteúdo pra ele) e cai para o conteúdo da rota como
 * fallback.
 */
interface HelpScopeState {
  scope: string | null;
  setScope: (scope: string | null) => void;
}

export const useHelpScopeStore = create<HelpScopeState>((set) => ({
  scope: null,
  setScope: (scope) => set({ scope }),
}));
